// src/components/StatCard.jsx
import styles from './StatCard.module.css';

export default function StatCard({ icon: Icon, label, value, color = 'blue', trend = null }) {
  return (
    <div className={styles.card}>
      <div className={styles.inner}>
        <div>
          <p className={styles.label}>{label}</p>
          <p className={styles.value}>{value}</p>
          {trend && <p className={styles.trend}>{trend}</p>}
        </div>
        {Icon && (
          <div className={`${styles.iconBadge} ${styles[color] ?? styles.blue}`}>
            <Icon size={24} aria-hidden="true" />
          </div>
        )}
      </div>
    </div>
  );
}
